import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

interface CallParticipant {
  id: string;
  userName: string;
  avatarUrl: string;
}

export interface TranslationHistoryItem {
  callDuration: string;
  client: CallParticipant | null;
  // #19/#31: організація дзвінка
  companyId?: number | null;
  companyName?: string | null;
  // GUID власника компанії (== адмінський id) — для переходу у картку компанії.
  companyOwnerId?: string | null;
  // #31: зовнішній/гість — третій учасник дзвінка з віджету
  external?: CallParticipant | null;
  createdAt: string;
  finishedAt: string;
  // Момент прийняття дзвінка (Created→Active).
  acceptedAt?: string | null;
  finishedBy: string;
  translator: CallParticipant | null;
  updatedAt: string;
  // Повні дані дзвінка для картки.
  status?: string | null;
  isScheduled?: boolean;
  rating?: number | null;
  ratingReason?: string | null;
  ratingComment?: string | null;
  comment?: string | null;
  // Контактні/облікові поля клієнта — для відкриття картки клієнта прямо з картки дзвінка.
  clientEmail?: string | null;
  clientPhone?: string | null;
  clientCreatedAt?: string | null;
  clientLastLoginAt?: string | null;
  clientEmailConfirmed?: boolean | null;
  clientComment?: string | null;
}

dayjs.extend(duration);

export const getFormattedDuration = (timeString: string) => {
  const parts = timeString.split(':');
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const secondsAndMs = parseFloat(parts[2]);

  const totalMilliseconds = (hours * 3600 + minutes * 60 + secondsAndMs) * 1000;

  const callDuration = dayjs.duration(totalMilliseconds, 'milliseconds');

  let formattedDuration;
  if (callDuration.asHours() < 1) {
    formattedDuration = callDuration.format('mm:ss');
  } else {
    formattedDuration = callDuration.format('HH:mm:ss');
  }

  return formattedDuration;
};
